<template>
  <div class="activity">
    <div class="banner">
      <img src="../../assets/banner.png" alt="">
    </div>
 
    <div class="activity_content container">
      <div class="activity_title">
        <span class="iconfont iconliebiao"></span>活动列表
      </div>
      <div class="activity_list">
        <el-row :gutter="20">
          <!-- <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12" v-for="item in 5" :key="item">
            <div class="list_item">
              <div class="item_left">
                <img src="../../assets/activity.png" alt="">
              </div>
              <div class="item_right">
                <div class="item_right_title e-line-1">
                  这是活动标题，这是活动标题，这是活动标题啊这是活动标题，这是活动标题，这是活动标题啊这是活动标题，这是活动标题，这是活动标题啊这是活动标题，这是活动标题，这是活动标题啊
                </div>
                <div class="item_right_content e-line-2">
                  这是活动内容啊，活动内容就是我啊，我就是活动内容啊，你能看到我吗我就是活动内容给你的互动内容！
                  ，我就是活动内容啊，你能看到我吗我就是活动内容给你的互动内容！
                  ，我就是活动内容啊，你能看到我吗我就是活动内容给你的互动内容！
                </div>
              </div>
            </div>
          </el-col> -->

           <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12" v-for="item in activityList" :key="item.id">
            <div class="list_item" @click="activityDetail(item.id)">
              <div class="item_left">
                <img src="../../assets/activity.png" alt="">
              </div>
              <div class="item_right">
                <div class="item_right_title e-line-1">
                  {{ item.activityName }}
                </div>
                <div class="item_right_content e-line-2">
                  {{ item.activityJianjie }}
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="pagination">
        <el-pagination
          background
          layout="prev, pager, next"
          :total="total"
          :current-page="dataform.page"
          @current-change="getActivityList"
          @prev-click="getActivityList"
          @next-click="getActivityList"
          >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'activity',
  data () {
    return {
      dataform: {
        page: 1,
        limit: 10
      },
      total: 0,
      activityList: ''
    }
  },
  mounted () {
    this.getActivityList()
  },
  methods: {
    activityDetail(id) {
      this.$router.push({ path: '/activityDetail', query: { id }})
    },
    async getActivityList() {
      console.log(this.dataform);
      let { data: { code, data }} = await this.$http.get('/activity/volunteeractivity/page', { params: this.dataform})
      console.log(data);
      if(code != 0) return
      this.activityList = data.list
      this.total = data.total
    }
  }
}
</script>

<style lang="scss" scoped>
.activity {
  .banner {
    img {
      width: 100%;
      height: 100%;
    }
  }
  .activity_content {                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
    .activity_title {
      font-size: 24px;
      line-height: 2;
      .iconliebiao {
        font-size: 28px;
        color: #3498db;
        margin-right: 5px;
      }
    }
    .activity_list { 
      .list_item {
        position: relative;
        top: 0;
        cursor: pointer;
        display: flex;
        margin: 10px 0;
        border: 2px solid #E4E7ED;
        padding: 10px;
        border-radius: 7px;
        transition: .2s ease-out;
        height: 85px;
       &:hover {
          box-shadow: 2px 2px 2px #C0C4CC;
          top: -3px
        }
        .item_left {
          margin-right: 10px;
          display: flex;
          justify-content: center;
          align-items: center;
          img {
            width: 50px;
            height: 50px;
            object-fit: contain;
          }
        }
        .item_right {
          line-height: 1.5;
          .item_right_title {
            line-height: 2;
            font-size: 18px;
            font-weight: 700;
            color: #303133;
          }
          .item_right_content {
            font-size: 16px;
            color: #606266;
          }
        }
      }
    }
    .pagination {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 20px 0 30px 0;
    }
  }
  
}
</style>